/**
 * App 内环/circle 帖子深链，与原生约定 path：circle/post?post_id&user_code&type
 */
export const POST_TYPE_IMAGE = 1;
export const POST_TYPE_VIDEO = 2;
export const CIRCLE_POST_PATH = 'circle/post';
export const ANDROID_QIPAO_PACKAGE = 'ai.yingsai.packageqipao';

/**
 * @param {object} p
 * @param {string} p.postId
 * @param {string} [p.userCode]
 * @param {1|2} p.type
 * @returns {string} application/x-www-form-urlencoded 查询串
 */
export function buildCirclePostQueryString(p) {
  const q = new URLSearchParams();
  q.set('post_id', p.postId);
  if (p.userCode) {
    q.set('user_code', p.userCode);
  }
  q.set('type', String(p.type));
  return q.toString();
}

/**
 * 用于 iframe / iOS：`qipao://circle/post?post_id&user_code&type`
 * 需在原生注册 `qipao` scheme 且 host/path 为 `circle/post`。
 * @param {object} p
 * @param {string} p.postId
 * @param {string} [p.userCode]
 * @param {1|2} p.type
 * @returns {string}
 */
export function buildQipaoCirclePostScheme(p) {
  return `qipao://${CIRCLE_POST_PATH}?${buildCirclePostQueryString(p)}`;
}

/**
 * Android：`intent://circle/post?post_id&user_code&type#Intent;...`
 * 需在 Manifest 中为 `qipao` + `circle/post` 配置 `intent-filter`，否则可能回落到 `S.browser_fallback_url`。
 * @param {object} p
 * @param {string} p.postId
 * @param {string} [p.userCode]
 * @param {1|2} p.type
 * @param {string} pkg
 * @param {string} fallbackUrl
 * @returns {string}
 */
export function buildAndroidIntentCirclePost(p, pkg, fallbackUrl) {
  const qs = buildCirclePostQueryString(p);
  return `intent://circle/post?${qs}#Intent;scheme=qipao;package=${pkg};S.post_id=${encodeURIComponent(
    p.postId
  )};S.type=${encodeURIComponent(String(p.type))};${
    p.userCode ? `S.user_code=${encodeURIComponent(p.userCode)};` : ''
  }S.browser_fallback_url=${encodeURIComponent(
    fallbackUrl
  )};end`;
}
